import { render, staticRenderFns } from "./UserProgressDiagram.vue?vue&type=template&id=04723a3c&scoped=true&"
import script from "./UserProgressDiagram.vue?vue&type=script&lang=js&"
export * from "./UserProgressDiagram.vue?vue&type=script&lang=js&"
import style0 from "./UserProgressDiagram.vue?vue&type=style&index=0&id=04723a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04723a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04723a3c')) {
      api.createRecord('04723a3c', component.options)
    } else {
      api.reload('04723a3c', component.options)
    }
    module.hot.accept("./UserProgressDiagram.vue?vue&type=template&id=04723a3c&scoped=true&", function () {
      api.rerender('04723a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/home/UserProgressDiagram.vue"
export default component.exports